/* Red Light Hero - device quiz engine.
   You should not need to edit this file. All content lives in rlh-quiz-data.js.

   Supports multiple quiz sections on one page. Each section element carries its
   own config JSON and its own live product map rendered by Liquid. */

(function () {
  'use strict';

  var INSTANCE_N = 0;
  var TRACK_PARAMS = /^(utm_|gclid|fbclid|ttclid|msclkid|epik|irclickid|wbraid|gbraid)/i;

  /* Show a real message in the section instead of leaving an empty box.
     Shoppers see a way to get help; you see the cause in the browser console. */
  function fail(message, detail) {
    console.error('[RLH quiz] ' + message, detail || '');
    function paint() {
      document.querySelectorAll('[data-rlh-quiz] [data-rlh-body]').forEach(function (body) {
        if (body.getAttribute('data-rlh-painted')) return;
        body.setAttribute('data-rlh-painted', 'error');
        body.innerHTML = '<p style="margin:0 0 10px"><strong>The device selector could not load.</strong></p>' +
          '<p style="margin:0 0 14px;color:#5f5d61">' + message + '</p>' +
          '<a class="rlh-btn" href="https://wa.me/61433736985" target="_blank" rel="noopener">Message us and we will recommend a device</a>';
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint);
    else paint();
  }

  var DATA = window.RLH_QUIZ_DATA;
  if (!DATA || !DATA.quizzes) {
    fail('The quiz content file did not load. Check that assets/rlh-quiz-data.js exists in the theme and has no syntax errors.');
    return;
  }

  /* ---------------------------------------------------------------- utils */

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function tpl(str, vars) {
    return String(str || '').replace(/\{(\w+)\}/g, function (m, k) {
      return vars[k] != null ? vars[k] : m;
    });
  }

  function inList(want, val) {
    if (Array.isArray(want)) return want.indexOf(val) !== -1;
    return want === val;
  }

  function money(cents, fallbackString) {
    if (fallbackString) return fallbackString;
    if (cents == null) return '';
    var n = cents / 100;
    return '$' + n.toLocaleString('en-AU', {
      minimumFractionDigits: n % 1 ? 2 : 0,
      maximumFractionDigits: 2
    });
  }

  /* ------------------------------------------------------- rules engine */

  function matches(cond, answers, resultKey) {
    for (var k in cond) {
      if (!Object.prototype.hasOwnProperty.call(cond, k)) continue;
      var want = cond[k];
      if (k === 'result') { if (!inList(want, resultKey)) return false; continue; }
      if (k === 'resultNot') { if (inList(want, resultKey)) return false; continue; }
      if (k.length > 3 && k.slice(-3) === 'Not') {
        if (inList(want, answers[k.slice(0, -3)])) return false;
        continue;
      }
      if (!inList(want, answers[k])) return false;
    }
    return true;
  }

  function resolve(quiz, answers) {
    var key = quiz.fallback;
    var rules = quiz.rules || [];
    for (var i = 0; i < rules.length; i++) {
      if (matches(rules[i].when || {}, answers)) { key = rules[i].result; break; }
    }

    var base = quiz.results[key];
    if (!base) {
      console.warn('[RLH quiz] no result defined for "' + key + '"');
      return null;
    }

    var out = {
      key: key,
      product: base.product,
      eyebrow: base.eyebrow || '',
      why: (base.why || []).slice(),
      note: base.note || '',
      alternates: (base.alternates || []).slice()
    };

    var mods = quiz.modifiers || [];
    for (var m = 0; m < mods.length; m++) {
      var mod = mods[m];
      if (!matches(mod.when || {}, answers, key)) continue;
      if (mod.why) out.why = [].concat(mod.why);
      if (mod.addWhy) out.why = out.why.concat(mod.addWhy);
      if (mod.eyebrow) out.eyebrow = mod.eyebrow;
      if (mod.product) out.product = mod.product;
      if (mod.note) out.note = mod.note;
      if (mod.noteIfEmpty && !out.note) out.note = mod.noteIfEmpty;
      if (mod.alternates) out.alternates = [].concat(mod.alternates);
      if (mod.addAlternate) {
        if (mod.addAlternate.position === 'start') out.alternates.unshift(mod.addAlternate);
        else out.alternates.push(mod.addAlternate);
      }
    }

    // Never offer the primary as an alternate, and never list one twice.
    var seen = {};
    seen[out.product] = true;
    out.alternates = out.alternates.filter(function (a) {
      if (!a || !a.product || seen[a.product]) return false;
      seen[a.product] = true;
      return true;
    });

    return out;
  }

  /* -------------------------------------------------------- one section */

  /* A malformed product map must never take the whole quiz down. Worst case we
     lose prices, and the fetch fallback below fills them back in. */
  function readJson(root, selector, label) {
    var el = root.querySelector(selector);
    if (!el) { console.warn('[RLH quiz] missing ' + label); return null; }
    try {
      return JSON.parse(el.textContent || 'null');
    } catch (e) {
      console.error('[RLH quiz] ' + label + ' is not valid JSON. Liquid probably printed an error into it. First 300 characters:\n' +
        (el.textContent || '').trim().slice(0, 300), e);
      return null;
    }
  }

  function Quiz(root) {
    this.root = root;
    this.cfg = readJson(root, '[data-rlh-config]', 'quiz configuration') || {};
    this.products = readJson(root, '[data-rlh-products]', 'product data') || {};
    this.fetched = {};
    this.uid = (root.id || 'rlh') + '-' + (++INSTANCE_N);
    // Theme editor fields left blank must not override the data file defaults.
    var over = this.cfg.settings || {};
    Object.keys(over).forEach(function (k) {
      if (over[k] === '' || over[k] === null || over[k] === undefined) delete over[k];
    });
    this.s = Object.assign({}, DATA.settings, over);
    this.carry = new URLSearchParams();

    var qs = new URLSearchParams(location.search);
    var self = this;
    if (this.s.carryUtms) {
      qs.forEach(function (v, k) { if (TRACK_PARAMS.test(k)) self.carry.append(k, v); });
    }

    this.available = (this.cfg.quizzes || []).filter(function (q) {
      var def = DATA.quizzes[q.slug];
      return def && def.enabled !== false;
    });

    this.el = {
      head: root.querySelector('[data-rlh-head]'),
      step: root.querySelector('[data-rlh-step]'),
      bar: root.querySelector('[data-rlh-bar]'),
      body: root.querySelector('[data-rlh-body]'),
      foot: root.querySelector('[data-rlh-foot]')
    };

    root.addEventListener('click', this.onClick.bind(this));
    root.addEventListener('keydown', this.onKey.bind(this));

    // Deep link: ?quiz=slug jumps straight into one quiz.
    var wanted = qs.get('quiz');
    var match = wanted && this.available.filter(function (q) { return q.slug === wanted; })[0];

    this.el.body.setAttribute('data-rlh-painted', 'ok');

    if (match) this.startQuiz(match.slug, true);
    else if (this.available.length > 1 && this.cfg.mode !== 'first') this.renderMenu();
    else if (this.available.length) this.startQuiz(this.available[0].slug, true);
    else {
      this.el.body.innerHTML =
        '<p style="margin:0 0 8px"><strong>No quiz chosen yet.</strong></p>' +
        '<p style="margin:0;color:#5f5d61">In the theme editor, open this section and add a <strong>Quiz</strong> block. ' +
        'Add one for a single quiz, or several to let visitors choose.</p>';
      console.warn('[RLH quiz] section has no Quiz blocks.', this.cfg);
    }

    this.track('rlh_quiz_view', { quizzes: this.available.length });
    this.decorate();
  }

  Quiz.prototype.track = function (name, detail) {
    if (!this.s.trackEvents) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name, section: this.cfg.sectionId || '' }, detail || {}));
  };

  Quiz.prototype.decorate = function () {
    if (!this.carry.toString()) return;
    var carry = this.carry;
    this.root.querySelectorAll('a[href^="/"], a[href*="' + location.hostname + '"]').forEach(function (a) {
      try {
        var u = new URL(a.getAttribute('href'), location.origin);
        carry.forEach(function (v, k) { if (!u.searchParams.has(k)) u.searchParams.append(k, v); });
        a.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (e) { /* ignore */ }
    });
  };

  Quiz.prototype.scrollIntoView = function () {
    if (!this.s.scrollOnAnswer) return;
    var top = this.root.getBoundingClientRect().top + window.scrollY - 80;
    if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
  };

  /* ------------------------------------------------------------- screens */

  Quiz.prototype.renderMenu = function () {
    this.mode = 'menu';
    this.quizSlug = null;
    var s = this.s;
    this.el.head.hidden = true;

    var items = this.available.map(function (q) {
      var def = DATA.quizzes[q.slug];
      var title = q.title || def.menuTitle || q.slug;
      var blurb = q.blurb || def.menuBlurb || '';
      var meta = q.meta || def.menuMeta || ((def.questions || []).length + ' questions');
      return '<button type="button" class="rlh-menu__item" data-rlh-pick="' + esc(q.slug) + '">' +
        '<span class="rlh-menu__meta">' + esc(meta) + '</span>' +
        '<span class="rlh-menu__title">' + esc(title) + '</span>' +
        '<p class="rlh-menu__blurb">' + esc(blurb) + '</p>' +
        '<span class="rlh-menu__go">' + esc(s.chooserCtaLabel) + '</span>' +
        '</button>';
    }).join('');

    this.el.body.className = 'rlh-quiz__body rlh-fade';
    this.el.body.innerHTML = '<div class="rlh-menu">' + items + '</div>';
    this.el.foot.hidden = true;
    this.decorate();
  };

  Quiz.prototype.startQuiz = function (slug, silent) {
    this.mode = 'quiz';
    this.quizSlug = slug;
    this.quiz = DATA.quizzes[slug];
    this.answers = {};
    this.index = 0;
    this.el.head.hidden = false;
    if (!silent) this.track('rlh_quiz_start', { quiz: slug });
    this.renderQuestion(silent);
  };

  Quiz.prototype.renderQuestion = function (silent) {
    var q = this.quiz.questions[this.index];
    var total = this.quiz.questions.length;
    var s = this.s;

    this.el.step.textContent = tpl(s.stepLabel, { n: this.index + 1, total: total });
    this.el.bar.style.width = Math.round((this.index / total) * 100) + '%';

    var opts = q.options.map(function (o) {
      return '<button type="button" class="rlh-opt" data-rlh-answer="' + esc(o.value) + '">' +
        '<b>' + esc(o.label) + '</b>' +
        (o.desc ? '<em>' + esc(o.desc) + '</em>' : '') +
        '</button>';
    }).join('');

    this.el.body.className = 'rlh-quiz__body rlh-fade';
    this.el.body.innerHTML =
      '<h3 class="rlh-quiz__q">' + esc(q.label) + '</h3>' +
      (q.help ? '<p class="rlh-quiz__help">' + esc(q.help) + '</p>' : '') +
      '<div class="rlh-quiz__opts' + (q.columns === 2 ? ' is-two' : '') + '" role="group" aria-label="' + esc(q.label) + '">' + opts + '</div>';

    var left = this.index > 0
      ? '<button type="button" class="rlh-link" data-rlh-back>' + esc(s.backLabel) + '</button>'
      : (this.available.length > 1 && this.cfg.mode !== 'first'
        ? '<button type="button" class="rlh-link" data-rlh-menu>' + esc(s.changeQuizLabel) + '</button>'
        : '<span>' + esc(s.firstStepNote) + '</span>');

    this.el.foot.hidden = false;
    this.el.foot.innerHTML = left +
      '<span class="rlh-right"><a class="rlh-link" href="' + esc(s.helpUrl) + '" target="_blank" rel="noopener">' + esc(s.helpLabel) + '</a></span>';

    if (!silent) {
      var first = this.el.body.querySelector('.rlh-opt');
      if (first) first.focus();
    }
  };

  Quiz.prototype.answer = function (value) {
    var q = this.quiz.questions[this.index];
    if (!this.started) { this.started = true; this.track('rlh_quiz_start', { quiz: this.quizSlug }); }
    this.answers[q.id] = value;
    this.track('rlh_quiz_answer', { quiz: this.quizSlug, step: this.index + 1, question: q.id, answer: value });
    this.index++;
    if (this.index >= this.quiz.questions.length) this.renderResult();
    else this.renderQuestion();
    this.scrollIntoView();
  };

  /* -------------------------------------------------------- product data */

  /* Work out which single variant the price on screen refers to.
     Price and compare-at MUST come from the same variant - Shopify's
     product-level compare_at_price is the minimum across all variants and can
     pair with a different variant's price, which would show a false discount. */
  Quiz.prototype.pickVariant = function (live, match) {
    if (!live || !live.variants || !live.variants.length) return null;

    var pool = live.variants;
    if (match) {
      var needle = String(match).toLowerCase();
      pool = live.variants.filter(function (v) {
        return String(v.title).toLowerCase().indexOf(needle) !== -1;
      });
      if (!pool.length) return null;
    }

    var inStock = pool.filter(function (v) { return v.available; });
    var chooseFrom = inStock.length ? inStock : pool;
    var chosen = chooseFrom.reduce(function (a, b) { return b.price < a.price ? b : a; });

    // More than one price in the pool means the figure shown is a "from" price.
    var prices = {};
    pool.forEach(function (v) { prices[v.price] = 1; });

    chosen.isFrom = Object.keys(prices).length > 1;
    chosen.poolSize = pool.length;
    return chosen;
  };

  Quiz.prototype.device = function (productKey) {
    var def = DATA.products[productKey];
    if (!def) { console.warn('[RLH quiz] unknown product key "' + productKey + '"'); return null; }
    var live = this.products[def.handle];

    // Always resolve to a variant when we have live data, even without a
    // variantMatch, so the price and its strike-through always agree.
    var variant = live ? this.pickVariant(live, def.variantMatch) : null;

    var url = live ? live.url : '/products/' + encodeURI(def.handle);
    if (variant && def.variantMatch) {
      url += (url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variant.id;
    }

    var price = variant ? variant.price : (live ? live.price : null);
    var compare = variant ? variant.compare_at : (live ? live.compare_at : null);

    return {
      key: productKey,
      name: def.name || (live && live.title) || productKey,
      tag: def.tag || '',
      specs: def.specs || [],
      url: url,
      img: (variant && variant.image) || (live && live.image) || '',
      price: price,
      priceText: variant ? variant.price_formatted : (live && live.price_formatted),
      // Only a genuine saving counts. Equal or lower compare-at is not a discount.
      compare: compare > price ? compare : null,
      compareText: variant ? variant.compare_at_formatted : (live && live.compare_at_formatted),
      isFrom: !!(variant && variant.isFrom),
      available: variant ? variant.available : (live ? live.available : true),
      live: !!live
    };
  };

  Quiz.prototype.priceHtml = function (d) {
    if (!this.s.showPrice || !d.priceText) return '';
    var s = this.s;

    var prefix = (d.isFrom && s.fromLabel) ? '<span class="rlh-price__from">' + esc(s.fromLabel) + '</span> ' : '';
    var now = '<strong class="rlh-price__now">' + esc(d.priceText) + '</strong>';

    // Strike-through only when there is a real compare-at price above the
    // selling price. Same price, lower price or none at all shows one figure.
    var was = '';
    if (d.compare && d.compareText) {
      was = ' <s class="rlh-price__was"><span class="rlh-sr">' + esc(s.wasLabel) + ' </span>' +
        esc(d.compareText) + '</s>';
      if (s.showSaving) {
        var pct = Math.round((1 - d.price / d.compare) * 100);
        if (pct >= 1) was += ' <span class="rlh-price__save">' + esc(tpl(s.saveLabel, { percent: pct })) + '</span>';
      }
    }

    var soldOut = d.available ? '' : '<span class="rlh-soldout">' + esc(s.soldOutLabel) + '</span>';
    return '<p class="rlh-price">' + prefix + now + was + soldOut + '</p>';
  };

  /* ------------------------------------------------- product fetch fallback */

  // Used only when a product is not in the collection the section reads from,
  // or when that map failed to parse. Keeps prices correct either way.
  Quiz.prototype.formatMoney = function (cents) {
    if (cents == null) return null;
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
    } catch (e) { /* fall through */ }
    var n = cents / 100;
    return '$' + n.toLocaleString(undefined, {
      minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2
    });
  };

  Quiz.prototype.absorb = function (handle, j) {
    var self = this;
    var money = function (c) { return self.formatMoney(c); };
    this.products[handle] = {
      title: j.title,
      url: '/products/' + j.handle,
      image: j.featured_image || (j.images && j.images[0]) || null,
      price: j.price,
      price_formatted: money(j.price),
      compare_at: j.compare_at_price || null,
      compare_at_formatted: j.compare_at_price ? money(j.compare_at_price) : null,
      available: j.available,
      variants: (j.variants || []).map(function (v) {
        return {
          id: v.id, title: v.title, price: v.price,
          price_formatted: money(v.price),
          compare_at: v.compare_at_price || null,
          compare_at_formatted: v.compare_at_price ? money(v.compare_at_price) : null,
          available: v.available,
          image: (v.featured_image && v.featured_image.src) || null
        };
      })
    };
  };

  Quiz.prototype.ensureProducts = function (keys) {
    var self = this;
    var handles = [];
    keys.forEach(function (k) {
      var def = DATA.products[k];
      if (def && !self.products[def.handle] && !self.fetched[def.handle]) handles.push(def.handle);
    });
    if (!handles.length || typeof fetch !== 'function') return Promise.resolve();

    return Promise.all(handles.map(function (h) {
      self.fetched[h] = true;
      return fetch('/products/' + encodeURI(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (j) self.absorb(h, j);
          else console.warn('[RLH quiz] could not load /products/' + h + '.js - check the handle in rlh-quiz-data.js');
        })
        .catch(function () { /* offline or blocked: render without a price */ });
    }));
  };

  /* ------------------------------------------------ citations + footnote 3

     A line of copy can be either a plain string, or an object:
       { t: 'the sentence', h: true, refs: ['study_key', ...] }
     h:true appends the footnote 3 marker (health claim).
     refs are keys into RLH_QUIZ_DATA.references and render as numbered links.
     Numbering is per result screen, in the order the studies first appear. */

  function lineText(line) {
    return typeof line === 'string' ? line : (line && line.t) || '';
  }

  Quiz.prototype.renderLine = function (line, cites) {
    if (typeof line === 'string') return line;
    if (!line || !line.t) return '';
    var html = line.t;
    var refs = DATA.references || {};

    // Study links first, as a single bracketed group: [1,2]
    var links = [];
    (line.refs || []).forEach(function (key) {
      var ref = refs[key];
      if (!ref) { console.warn('[RLH quiz] unknown reference key "' + key + '"'); return; }
      var i = cites.order.indexOf(key);
      if (i === -1) { cites.order.push(key); i = cites.order.length - 1; }
      links.push('<a href="' + esc(ref.url) + '" target="_blank" rel="noopener" title="' +
        esc(ref.label) + '">' + (i + 1) + '</a>');
    });
    if (links.length) html += '<sup class="rlh-cite">[' + links.join(',') + ']</sup>';

    // Then the footnote 3 marker, as the literal character so it can never be
    // mistaken for a study number.
    if (line.h) {
      html += '<sup class="rlh-fn"><a href="#rlh-fn3-' + this.uid + '" title="Read the disclaimer">³</a></sup>';
      cites.health = true;
    }
    return html;
  };

  Quiz.prototype.renderCitations = function (cites) {
    var refs = DATA.references || {};
    var s = this.s;
    var out = '';

    if (cites.order.length) {
      out += '<div class="rlh-refs"><h4>' + esc(s.referencesHeading) + '</h4><ol>' +
        cites.order.map(function (key) {
          var r = refs[key];
          return '<li><a href="' + esc(r.url) + '" target="_blank" rel="noopener">' + esc(r.label) + '</a></li>';
        }).join('') +
        '</ol>' +
        (s.referencesNote ? '<p class="rlh-refs__note">' + esc(s.referencesNote) + '</p>' : '') +
        '</div>';
    }

    if (cites.health && DATA.footnote3) {
      out += '<p class="rlh-fn3" id="rlh-fn3-' + this.uid + '">' + esc(DATA.footnote3) + '</p>';
    }
    return out;
  };

  /* --------------------------------------------------------- result view */

  Quiz.prototype.renderResult = function () {
    var self = this;
    var res = resolve(this.quiz, this.answers);
    if (!res) {
      this.el.body.innerHTML = '<p>Something went wrong picking a result. Please start over.</p>';
      return;
    }
    var needed = [res.product].concat((res.alternates || []).map(function (a) { return a.product; }));
    this.ensureProducts(needed).then(function () { self.paintResult(res); });
  };

  Quiz.prototype.paintResult = function (res) {
    var s = this.s;
    var d = this.device(res.product);
    if (!d) { this.el.body.innerHTML = '<p>Something went wrong loading that product. Please start over.</p>'; return; }

    this.el.step.textContent = s.resultStepLabel;
    this.el.bar.style.width = '100%';

    var self = this;
    var cites = { order: [], health: false };
    var alts = s.showAlternates
      ? res.alternates.slice(0, s.maxAlternates).map(function (a) {
          var ad = self.device(a.product);
          if (!ad) return '';
          return '<div class="rlh-alt">' +
            '<b>' + esc(ad.name) + (ad.available ? '' : '<span class="rlh-soldout">' + esc(s.soldOutLabel) + '</span>') + '</b>' +
            '<span>' + self.renderLine(a.why, cites) + '</span>' +
            '<a class="rlh-btn rlh-btn--ghost rlh-btn--sm" href="' + esc(ad.url) + '" data-rlh-cta="alt">' +
              esc(tpl(s.altCtaTemplate, { name: ad.name })) + '</a>' +
            '</div>';
        }).join('')
      : '';

    this.el.body.className = 'rlh-quiz__body rlh-fade';
    this.el.body.innerHTML =
      '<p class="rlh-result__eyebrow">' + esc(res.eyebrow) + '</p>' +
      '<div class="rlh-rec">' +
        (d.img ? '<div class="rlh-rec__img"><img src="' + esc(d.img) + '" alt="' + esc(d.name) + '" loading="lazy" width="230" height="210"></div>' : '') +
        '<div>' +
          (d.tag ? '<p class="rlh-rec__tag">' + esc(d.tag) + '</p>' : '') +
          '<h3 class="rlh-rec__name">' + esc(d.name) + '</h3>' +
          this.priceHtml(d) +
          '<ul class="rlh-why">' + res.why.map(function (w) { return '<li>' + self.renderLine(w, cites) + '</li>'; }).join('') + '</ul>' +
          (s.showSpecs && d.specs.length ? '<ul class="rlh-specs">' + d.specs.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>' : '') +
          '<div class="rlh-btnrow">' +
            '<a class="rlh-btn" href="' + esc(d.url) + '" data-rlh-cta="primary">' + esc(tpl(s.primaryCtaTemplate, { name: d.name })) + '</a>' +
            (s.secondaryCtaUrl ? '<a class="rlh-btn rlh-btn--ghost" href="' + esc(s.secondaryCtaUrl) + '" target="_blank" rel="noopener" data-rlh-cta="secondary">' + esc(s.secondaryCtaLabel) + '</a>' : '') +
          '</div>' +
          (res.note ? '<p class="rlh-note">' + self.renderLine(res.note, cites) + '</p>' : '') +
        '</div>' +
      '</div>' +
      (alts ? '<div class="rlh-alts"><h4>' + esc(s.altsHeading) + '</h4><div class="rlh-alts__grid">' + alts + '</div></div>' : '') +
      this.renderCitations(cites);

    this.el.foot.hidden = false;
    this.el.foot.innerHTML =
      '<button type="button" class="rlh-link" data-rlh-restart>' + esc(s.restartLabel) + '</button>' +
      (this.available.length > 1 && this.cfg.mode !== 'first'
        ? ' <button type="button" class="rlh-link" data-rlh-menu>' + esc(s.changeQuizLabel) + '</button>' : '') +
      '<span class="rlh-right"><a class="rlh-link" href="' + esc(s.helpUrl) + '" target="_blank" rel="noopener">' + esc(s.resultHelpLabel) + '</a></span>';

    this.decorate();
    this.track('rlh_quiz_complete', {
      quiz: this.quizSlug,
      result: res.key,
      product: d.name,
      answers: JSON.stringify(this.answers)
    });
  };

  /* -------------------------------------------------------------- events */

  Quiz.prototype.onClick = function (e) {
    var t = e.target;
    var pick = t.closest('[data-rlh-pick]');
    if (pick) { this.startQuiz(pick.getAttribute('data-rlh-pick')); this.scrollIntoView(); return; }

    var opt = t.closest('[data-rlh-answer]');
    if (opt) { this.answer(opt.getAttribute('data-rlh-answer')); return; }

    if (t.closest('[data-rlh-back]')) { this.index = Math.max(0, this.index - 1); this.renderQuestion(); return; }
    if (t.closest('[data-rlh-restart]')) { this.answers = {}; this.index = 0; this.renderQuestion(); this.track('rlh_quiz_restart', { quiz: this.quizSlug }); return; }
    if (t.closest('[data-rlh-menu]')) { this.renderMenu(); return; }

    var cta = t.closest('[data-rlh-cta]');
    if (cta) {
      this.track('rlh_quiz_cta', {
        quiz: this.quizSlug,
        kind: cta.getAttribute('data-rlh-cta'),
        label: (cta.textContent || '').trim().slice(0, 60),
        href: cta.getAttribute('href')
      });
    }
  };

  Quiz.prototype.onKey = function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var focusables = Array.prototype.slice.call(this.root.querySelectorAll('.rlh-opt, .rlh-menu__item'));
    var i = focusables.indexOf(document.activeElement);
    if (i === -1) return;
    e.preventDefault();
    var next = e.key === 'ArrowDown' ? i + 1 : i - 1;
    if (next < 0) next = focusables.length - 1;
    if (next >= focusables.length) next = 0;
    focusables[next].focus();
  };

  /* ----------------------------------------------------------- bootstrap */

  var instances = [];

  function init(scope) {
    (scope || document).querySelectorAll('[data-rlh-quiz]:not([data-rlh-ready])').forEach(function (el) {
      el.setAttribute('data-rlh-ready', '1');
      try { instances.push(new Quiz(el)); } catch (err) { console.error('[RLH quiz]', err); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Shopify theme editor: re-initialise when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.RLHQuiz = { init: init, resolve: resolve, matches: matches, instances: instances };
})();